export const envVars = {
  dev: {
    apiUri: 'http://localhost:8080'
  },
  qa: {
    apiUri: 'https://covid-response-api-qa.pub.cloud-02.pcf.ascension.org'
  },
  prod: {
    apiUri: 'https://covid-response-api.pub.cloud-03.pcf.ascension.org'
  }
};

export const getEnvVars = host => {
  switch (host) {
    case 'localhost:3000':
      return envVars.dev;

    case 'daily-covid-response-ui.pub.cloud-02.pcf.ascension.org':
      return envVars.dev;

    case 'daily-covid-response-ui.app.cloud-02.pcf.ascension.org':
      return envVars.dev;

    case 'daily-covid-response-ui-dev.pub.cloud-02.pcf.ascension.org':
      return envVars.dev;

    case 'daily-covid-response-ui-qa.pub.cloud-02.pcf.ascension.org':
      return envVars.qa;

    case 'daily-covid-response-ui-qa.app.cloud-02.pcf.ascension.org':
      return envVars.qa;

    case 'daily-covid-response-ui.pub.cloud-03.pcf.ascension.org':
      return envVars.prod;

    case 'daily-covid-response-ui.app.cloud-03.pcf.ascension.org':
      return envVars.prod;

    default:
      return {};
  }
};
